import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { brand, tailwindColors } from "../../theme/gitoColors";

export default function AgentMarkdown({ text }) {
    if (!text) {
        return null;
    }

    return (
        <div className="agent-markdown overflow-x-auto text-sm text-mute-900 leading-relaxed break-words">
            <ReactMarkdown
                remarkPlugins={[remarkGfm]}
                components={{
                    h1: ({ children }) => <h1 className="text-lg font-bold mt-2 mb-1">{children}</h1>,
                    h2: ({ children }) => <h2 className="text-base font-bold mt-2 mb-1">{children}</h2>,
                    h3: ({ children }) => <h3 className="text-sm font-bold mt-2 mb-1">{children}</h3>,
                    p: ({ children }) => <p className="mb-2 last:mb-0">{children}</p>,
                    ul: ({ children }) => <ul className="list-disc pl-5 mb-2 space-y-1">{children}</ul>,
                    ol: ({ children }) => <ol className="list-decimal pl-5 mb-2 space-y-1">{children}</ol>,
                    li: ({ children }) => <li>{children}</li>,
                    a: ({ href, children }) => (
                        <a
                            href={href}
                            className="underline"
                            style={{ color: brand.darkBlue }}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {children}
                        </a>
                    ),
                    code: ({ className, children }) =>
                        className ? (
                            <code
                                className="block overflow-x-auto rounded-lg p-3 font-mono text-xs mb-2"
                                style={{ backgroundColor: tailwindColors.mute[50] }}
                            >
                                {children}
                            </code>
                        ) : (
                            <code
                                className="rounded px-1 py-0.5 font-mono text-xs"
                                style={{ backgroundColor: tailwindColors.mute[50] }}
                            >
                                {children}
                            </code>
                        ),
                    table: ({ children }) => (
                        <div className="mb-2 overflow-x-auto">
                            <table className="min-w-full border-collapse text-xs">{children}</table>
                        </div>
                    ),
                    th: ({ children }) => (
                        <th
                            className="border px-2 py-1 text-left font-bold"
                            style={{
                                borderColor: tailwindColors.mute[200],
                                backgroundColor: tailwindColors.mute[50],
                            }}
                        >
                            {children}
                        </th>
                    ),
                    td: ({ children }) => (
                        <td
                            className="border px-2 py-1"
                            style={{ borderColor: tailwindColors.mute[200] }}
                        >
                            {children}
                        </td>
                    ),
                }}
            >
                {text}
            </ReactMarkdown>
        </div>
    );
}
